import { useEffect, useState } from "react";
import { Upload, Check } from "lucide-react";
import api from "@/api/client";
import { toast } from "sonner";

function VideoSlot({ label, field, value, onSaved }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      await api.put("/settings/homepage", { [field]: data.url, ...(field === "hero_video_1" ? { hero_video_2: undefined } : { hero_video_1: undefined }) });
      const current = await api.get("/settings/homepage");
      await api.put("/settings/homepage", { ...current.data, [field]: data.url });
      toast.success(`${label} updated`);
      onSaved();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="border border-white/10 bg-surface p-4" data-testid={`video-slot-${field}`}>
      <p className="mb-3 font-mono text-xs uppercase tracking-widest text-slate-500">{label}</p>
      {value ? (
        <video src={value} muted loop autoPlay playsInline className="mb-3 h-48 w-full border border-white/10 object-cover" data-testid={`preview-${field}`} />
      ) : (
        <div className="mb-3 flex h-48 items-center justify-center border border-dashed border-white/10 font-mono text-xs uppercase text-slate-600" data-testid={`empty-${field}`}>
          No video set
        </div>
      )}
      <label className={`flex cursor-pointer items-center justify-center gap-2 border border-white/10 py-3 font-mono text-xs uppercase tracking-widest transition-colors hover:border-volt hover:text-volt ${uploading ? "opacity-50" : ""}`} data-testid={`upload-${field}`}>
        <Upload className="h-4 w-4" />
        {uploading ? "Uploading..." : "Upload New Video (mp4)"}
        <input type="file" accept="video/mp4,video/quicktime" className="hidden" onChange={handleFile} disabled={uploading} />
      </label>
      <p className="mt-2 font-mono text-xs text-slate-600">iPhone videos are converted automatically so they play in all browsers.</p>
    </div>
  );
}

export function AdminHomepage() {
  const [settings, setSettings] = useState(null);

  const load = () => api.get("/settings/homepage").then(({ data }) => setSettings(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  if (!settings) return <p className="font-mono text-sm text-slate-500">Loading...</p>;

  return (
    <div data-testid="homepage-settings">
      <p className="mb-4 text-sm text-slate-400">These are the two videos on your homepage — the main background at the top, and the "Ride Electric" section below it.</p>
      <div className="grid gap-6 md:grid-cols-2">
        <VideoSlot label="Main Screen Video (top)" field="hero_video_1" value={settings.hero_video_1} onSaved={load} />
        <VideoSlot label="Ride Electric Section Video" field="hero_video_2" value={settings.hero_video_2} onSaved={load} />
      </div>
    </div>
  );
}
